/**
 * Hands the post being edited from the Posts screen to the composer —
 * route params carry only the postId (they end up in the web URL), the
 * post itself stays in memory. If it's gone (page reload), the composer
 * falls back to creating a new post.
 */
import type { RecentPost } from '../screens/dashboard/RecentPostsCard';

let editing: RecentPost | null = null;

export const setPostToEdit = (post: RecentPost | null) => { editing = post; };

export const takePostToEdit = (postId?: string): RecentPost | null =>
  postId && editing?.postId === postId ? editing : null;
